<template>
    <v-skeleton-loader
        max-width="300"
        type="list-item-avatar-two-line@3"
        :loading="loading"
    >

      <v-list dense two-line subheader>
        <v-subheader>{{ savedCardMessage }}</v-subheader>
        <v-radio-group  v-model="selectedCard">
          <SelectSavedCardListItem
              v-for="(card, index) in savedCardsMinusExpiredCards"
              :card="card"
              :selected="selected"
              :key="index"
          />
        </v-radio-group>
      </v-list>
      <AddNewCardFormModal/>
    </v-skeleton-loader>
</template>
<script>
import { mapGetters } from 'vuex';
import SavedCardsMixin from '_GLOBAL/mixins/SavedCardsMixin';
import AddNewCardFormModal from './AddNewCardFormModal';
import SelectSavedCardListItem from './SelectSavedCardListItem';

export default {
  name: 'SelectSavedCardsList',
  data() {
    return {
      loading: false,
    };
  },
  mixins: [SavedCardsMixin],
  props: {
    selected: {
      required: false,
    },
  },

  computed: {
    ...mapGetters(['savedCards', 'globalLoading']),
    selectedCard: {
      get() {
        return this.$store.getters.selectedCard;
      },
      set(value) {
        this.$store.dispatch('UPDATE_SELECTED_CARD', value);
      },
    },

    savedCardsMinusExpiredCards() {
      return Object.values(this.savedCards)
        .filter(this.removeExpiredCardsFilter)
        .sort(this.savedCardDescExpiryDateSort);
    },

    savedCardMessage() {
      return this.savedCards.length === 0 ? 'Please add a card' : 'Please select a card to pay with or add another';
    },
  },

  watch: {},

  methods: {},

  async created() {
    if (!this.savedCards.length > 0) {
      this.loading = true;
      await this.$store.dispatch('GET_SAVED_CARDS');
      this.loading = false;
    }

    if (this.$route.params.card) {
      this.selectedCard = this.$route.params.card;
    } else if (this.selected) {
      this.selectedCard = this.savedCards.find((card) => this.matchSelected(card));
    } else if (this.savedCards.length > 0) {
      this.selectedCard = this.savedCards[0];
    }
  },
  mounted() {
  },
  updated() {
    // console.log('selected card in updated in SelectSavedCardList ', this.selectedCard);
  },

  components: {
    AddNewCardFormModal,
    SelectSavedCardListItem,
  },
};
</script>

<style lang="scss" scoped>
    @import '%/scss/_Color.sass';

    .fa-cc-visa {
        color: $visa !important;
    }

    .fa-cc-mastercard {
        color: $mastercard !important;
    }

    .fa-cc-amex {
        color: $amex !important;
    }
</style>
